export default defineNuxtPlugin(() => {
  if (process.env.NODE_ENV !== 'production') return

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    'gtm.start': new Date().getTime(),
    event: 'gtm.js'
  })

  const script = document.createElement('script')
  script.src = 'https://www.googletagmanager.com/gtm.js?id=GTM-PHWXP4X'
  script.async = true

  document.head.appendChild(script)
})
